import { getUser } from '@/service/user'
import { of, iif } from 'rxjs'
import { pluck, map, tap, mapTo } from 'rxjs/operators'
import resources from '@/store/modules/resources.js'

const trialExpiration = () =>
  resources.state.resources.general.message.trialExpiration

const getInviteUserMessage = totalInvitedUsers => {
  const personsToInvite = getUser().reportMinimumUsers - totalInvitedUsers
  const msg =
    personsToInvite > 1
      ? `${personsToInvite} ${trialExpiration().people}`
      : `${personsToInvite} ${trialExpiration().person}`
  const text = `${
    trialExpiration().invite
  } <span class="text-red02">${msg}</span> ${trialExpiration().discover}`

  return {
    text,
    id: 'inviteUser',
    status: 'warning',
    classes: 'message-invite-user',
    button: {
      text: trialExpiration().inviteNow,
      show: true,
      classes: 'btn btn-red02',
      click: function() {
        this.$router.push({ name: 'dashboard.users.send.invite' })
        this.$root.$emit('track', {
          event: 'Clicou em convide agora na barra superior',
          data: { category: 'App' },
        })
      },
    },
    ignoreBeforeTransition: true,
  }
}

export const showInviteUsersMessage = emit => notifications => {
  const notifications$ = of(notifications)

  const notify = iif(
    () =>
      !isNaN(notifications.totalInvitedUsers) &&
      notifications.totalInvitedUsers < getUser().reportMinimumUsers,
    of(notifications).pipe(
      pluck('totalInvitedUsers'),
      map(getInviteUserMessage),
      tap(emit),
      mapTo({})
    ),
    of(notifications)
  )

  notify.subscribe()

  return notifications$
}
